import React from 'react';

/**
 * GeneralSettings - Panel for configuring general quiz options
 * 
 * @param {Object} props
 * @param {Object} props.settings - Current settings object
 * @param {Function} props.onUpdateSettings - Callback to update settings (receives partial settings object)
 */
function GeneralSettings({ settings = {}, onUpdateSettings }) {
  return (
    <div className="space-y-3">
      {/* Anonymous Mode Setting */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
        <div>
          <span className="text-sm text-gray-700">👤 Anonymes Quiz</span>
          <p className="text-xs text-gray-500">Teilnehmer treten ohne Namen bei</p>
        </div>
        <input
          type="checkbox"
          checked={settings.anonymousMode ?? false}
          onChange={(e) => onUpdateSettings({ anonymousMode: e.target.checked })}
          className="w-5 h-5 text-gray-600 rounded focus:ring-gray-500"
        />
      </label>
      
      {/* Quiz Start Mode */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
        <div>
          <span className="text-sm text-gray-700">🚀 Intro-Bildschirm vor Start</span>
          <p className="text-xs text-gray-500">Teilnehmer sehen "Quiz startet gleich..." bis zur ersten Frage</p>
        </div>
        <input
          type="checkbox"
          checked={settings.showIntroScreen ?? false}
          onChange={(e) => onUpdateSettings({ showIntroScreen: e.target.checked })}
          className="w-5 h-5 text-gray-600 rounded focus:ring-gray-500"
        />
      </label>
      
      {/* Multiple Choice Hint Setting */}
      <label className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
        <div>
          <span className="text-sm text-gray-700">☑️ Multiple-Choice-Hinweis anzeigen</span>
          <p className="text-xs text-gray-500">Zeigt Teilnehmern an, wenn mehrere Antworten möglich sind</p>
        </div>
        <input
          type="checkbox"
          checked={settings.showMultipleChoiceHint ?? true}
          onChange={(e) => onUpdateSettings({ showMultipleChoiceHint: e.target.checked })}
          className="w-5 h-5 text-gray-600 rounded focus:ring-gray-500"
        />
      </label>
    </div>
  );
}

export default GeneralSettings;
